const benefits = [
  { icon: 'ri-money-dollar-circle-line', label: 'Sermaye Harcamalarını Azaltın' },
  { icon: 'ri-shield-check-line', label: 'Uyumluluğu Kolaylaştırın' },
  { icon: 'ri-team-line', label: 'BT Beceri Açığını Kapatın' },
  { icon: 'ri-rocket-line', label: 'Ölçeklenebilirliği Artırın' },
  { icon: 'ri-price-tag-3-line', label: 'Öngörülebilir Maliyetler' },
  { icon: 'ri-star-smile-line', label: 'Hayatınızı Kolaylaştırın' },
];

export default function PowerOfOne() {
  return (
    <section id="power-of-one" className="w-full bg-white py-20 px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left: Text */}
          <div>
            <h2 className="text-3xl font-bold text-[#1a1a2e] mb-5">BİR'in Gücü</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-4">
              VergeIO, önde gelen sanallaştırma yazılımının en iyi alternatifidir. Geleneksel BT yığınını (sanallaştırma, depolama ve ağ iletişimi) tek bir entegre veri merkezi işletim ortamına dönüştüren aşırı birleşik altyapısıyla (UCI) öne çıkar.
            </p>
            <p className="text-[#374151] text-base leading-relaxed mb-6">
              VergeOS&apos;un verimliliği, mevcut donanım yoğunluğunu artırarak iş yüklerini daha iyi yönetmenizi sağlar; veri esnekliğini geliştirir ve sonuç olarak dramatik şekilde düşük maliyetler, iyileştirilmiş kullanılabilirlik ve büyük ölçüde basitleştirilmiş bir BT ortamı sunar.
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {benefits.map((b) => (
                <div key={b.label} className="flex items-center gap-2 text-sm text-[#374151]">
                  <span className="w-5 h-5 flex items-center justify-center text-[#e8600a]">
                    <i className={`${b.icon} text-base`}></i>
                  </span>
                  {b.label}
                </div>
              ))}
            </div>
          </div>

          {/* Right: Architecture diagram */}
          <div className="flex justify-center">
            <div className="w-full max-w-[520px] h-[340px] rounded-xl overflow-hidden border border-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/7b78ce91b79c5fe8cada0b05a860bf91.jpg"
                alt="VergeOS Mimari Diyagramı"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
